<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActive"
  >
    <div id="loading-add-ehs-sidebar" class="vs-con-loading__container">
      <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{$t('add')}} {{$t('new')}} {{$t('element')}}</h4>
        <feather-icon icon="XIcon" @click.stop="close" class="cursor-pointer"></feather-icon>
      </div>
      <vs-divider class="mb-0"></vs-divider>

      <component
        :is="scrollbarTag"
        class="scroll-area--data-list-add-new"
        :settings="settings"
        :key="$vs.rtl"
      >
     
        <div class="p-6">
          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <vs-checkbox v-model="planned" class="ml-0">{{ $t('planned') | capitalize }}</vs-checkbox>
            </div>
          </div> 
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label>{{$t('client')}}</label>
              <v-select
                :options="clients"
                label="ShortName"
                :reduce="client => client.ClientId"
                v-model="client"
                v-validate="'required'"
                name="client"
                class="w-full"
                @input="getFacilities"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('client')"
              >{{ errors.first('client') }}</span>
            </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label>{{$t('building_number')}}</label>
              <v-select
                :options="facilities"
                label="name"
                :reduce="facility => facility.value"
                v-model="buildingNumber"
                v-validate="'required'"
                name="building_number"
                class="w-full"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('building_number')"
              >{{ errors.first('building_number') }}</span>
            </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label>{{$t('agency')}}</label>
              <v-select
                :options="categories"
                label="name"
                :reduce="category => category.id"
                v-model="category"
                v-validate="'required'"
                name="category"
                class="w-full"
                @input="getCatalogs"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('category')"
              >{{ errors.first('category') }}</span>
            </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label>{{$t('name')}}</label>
              <v-select
                :options="catalogs"
                label="activity_name"
                :reduce="catalog => catalog.id"
                v-model="name"
                v-validate="'required'"
                name="name"
                class="w-full"
                @input="setDuration"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('name')"
              >{{ errors.first('name') }}</span>
            </div>
          </div>

           <input-date
              v-model="date" 
              :value="date"
              :label="$t('start_date')" />

          <!-- <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label>{{$t('start')}}</label>
              <vs-input
                class="w-full"
                type="text"
                v-mask="'##/##/####'"
                v-model="date"
                name="date"
                v-validate="'required'"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('date')"
              >{{ errors.first('date') }}</span>
            </div>
          </div> -->

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
             <label>{{$t('frequency')}}</label>
              <v-select
                :options="frequencies"
                label="name"
                :reduce="frequency => frequency.id"
                v-model="frequency"
                v-validate="'required'"
                name="frequency"
                class="w-full"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('frequency')"
              >{{ errors.first('frequency') }}</span>
            </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label>{{$t('duration')}} ({{$t('days')}})</label>
              <vs-input-number
                min="1"
                v-model="duration"
                name="duration"
                class="w-full"
                v-validate="'required'"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('duration')"
              >{{ errors.first('duration') }}</span>
            </div>
          </div>
            <input-date
              v-model="expirationDate" 
              :value="expirationDate"
              :label="$t('expiration_date')" 
              class="mb-4" />
            <div class="mb-4">
              <input
                type="file"
                name="file"
                label="File"
                ref="file"
                class="w-full"
                @change="changeFile"
              />
          </div>
        </div>
      </component>

      <div class="flex flex-wrap items-center p-6" slot="footer">
        <vs-button
          class="mr-6"
          @click.stop.prevent="submit()"
          :disabled="!validForm"
        >{{$t('submit')}}</vs-button>
        <vs-button type="border" color="danger" @click.stop="close">{{$t('cancel')}}</vs-button>
      </div>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
import axios from 'axios'
import ehsCatalog from '@/http/requests/ehsCatalog'
import ehs from '@/http/requests/ehs'
import InputDate from '@/components/custom/InputDate.vue'

export default {
  props: {
    clients: {
      required: true
    },
    categories: {
      required: true
    },
    frequencies:{
      required:true
    }
  },
  data () {
    return {
      title: 'ADD NEW ITEM',
      client: null,
      category: null,
      name: null,
      date: '',
      expirationDate: '',
      file: '',
      duration: 1,
      buildingNumber:null,
      frequency:null,
      catalogs: [{ id: null, activity_name: 'SELECT AGENCY' }],
      facilities:[{ value: null, name: 'SELECT FACILITY' }],
      planned: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
    }
  },
  computed: {
    isSidebarActive () {
      return (
        this.$store.state.sidebar === 'addEhs'
      )
    },
    scrollbarTag () {
      return this.$store.getters.scrollbarTag
    },
    validForm() {
      return this.name !== 0 && this.buildingNumber !== null  && this.frequency !== null 
    }
  },
  watch: {
    isSidebarActive (val) {
      if (val) {
        this.init()
      }
      
    }
  },
  methods: {
    init() {
      this.client = this.clients[0].ClientId
      this.category = this.categories[0].id
      this.frequency = this.frequencies[0].id     
      this.buildingNumber = this.facilities[0].value
      this.getCatalogs()
      this.date = ''
      this.duration = 1
      this.getFacilities()
      this.expirationDate = ''
      this.file = ''
      this.$refs.file.value = ''
      this.planned = false
    },
    close () {
      this.$store.dispatch('toggleSidebar', '')
    },
    getCatalogs() {
      this.openLoading()
      let params = {
          agency_id: this.category
        }
      ehsCatalog.getCatalog(params).then(res => {
        if (res.data.catalogs.length > 0) {
          this.catalogs = res.data.catalogs
        } else {
          this.catalogs = [{ id: 0, activity_name: 'Name not Available' }]
        }
        this.name = this.catalogs[0].id
        this.duration = this.catalogs[0].duration ? this.catalogs[0].duration : 1
        this.closeLoading()
      })
      .catch(err => {
        this.closeLoading()
        this.$vs.notify({
          color: 'danger',
          title: 'Alert',
          text: 'SERVER ERROR'
        })
      })
    },
    getFacilities(){
      this.openLoading()
      ehs.getFacilities(this.client)
      .then(res => {
        if (res.data.facilities.length > 0) {
          this.facilities = res.data.facilities.map(({name}) => ({value:name,name:name}))
          
        }else{
          this.facilities=[{ value: null, name: 'SELECT FACILITY' }];
        }
        this.buildingNumber = this.facilities[0].value
        this.closeLoading()
      })
      .catch(err => {
        this.closeLoading()
        this.$vs.notify({
          color: 'danger',
          title: 'Alert',
          text: 'SERVER ERROR'
        })
      })

    },
    submit() {
      this.openLoading()
      let form = new FormData()
      form.append('client_id', this.client)
      form.append('category_id', this.category)
      form.append('catalog_id', this.name)
      form.append('start_date', this.date)
      form.append('duration', this.duration)
      form.append('building_number', this.buildingNumber)
      form.append('frequency', this.frequency)
      form.append('expiration_date', this.expirationDate)
      form.append('file', this.file)   
      if(this.planned){
         form.append('planned',this.planned)
      }
      this.$store.dispatch('ehs/addEhs', form)
        .then(res => {
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Item Added'
          })
          this.closeLoading()
          this.close()
          this.$emit('success')
        })
        .catch(err => {
          this.closeLoading()
          if (422 === err.response.status) {
            let errors = err.response.data.errors
            let errorArray = Object.keys(errors).map(function (key) {
              return [key, errors[key]]
            })
            errorArray.forEach(element => {
              this.$vs.notify({
                color: 'danger',
                title: 'Alert',
                text: element[1][0]
              })
            })
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Alert',
              text: 'SERVER ERROR'
            })
          }
        })
    this.closeLoading()
    },
    openLoading() {
      this.$vs.loading({
        container: '#loading-add-ehs-sidebar',
        scale: 0.6
      })
    },
    closeLoading() {
      this.$vs.loading.close('#loading-add-ehs-sidebar > .con-vs-loading')
    },
    setDuration(){
      let catalog = this.catalogs.find((catalog) => this.name == catalog.id)
      this.duration = catalog ? catalog.duration : 1
    },
    changeFile () {
      this.file = this.$refs.file.files[0]
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
    InputDate
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
